export default "__VITE_ASSET__Dg83eLOA__"